import { BackendError } from "types/utils/error";

export const SensitiveDataErrorState = ({ error }: { error?: unknown }) => {
  const message =
    (error as BackendError)?.data?.error?.message ??
    "We could not load the sensitive data for this entity.";

  return (
    <div className="t-flex t-min-h-[60dvh] t-w-full t-flex-col t-items-center t-justify-center t-gap-1 t-rounded-lg t-bg-surface-lighter-grey t-text-center">
      <span className="t-text-subtext-sm t-text-text-60">
        Something went wrong
      </span>
      <span className="t-text-body-sm t-max-w-md t-text-neutral-50">
        {message}
      </span>
    </div>
  );
};
